import dayjs from "dayjs";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Countdown from "react-countdown";
import { useTotalTickets } from "helpers/hooks";

const RaffleItem = ({ raffle }: { raffle: any }) => {
  const date1 = dayjs(raffle.endDate);
  const ended = date1.diff(new Date(), "second") < 0;

  const totalTickets = useTotalTickets(raffle, ended);

  //
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <>Ended</>;
    } else {
      // Render a countdown
      return (
        <>
          {days > 0 && `${days}d`} {hours > 0 && `${hours}hrs`}{" "}
          {minutes > 0 && `${minutes}mins`} {String(seconds).padStart(2, "0")}s
        </>
      );
    }
  };

  return (
    <RaffleItemContainer>
      <RaffleItemImage
        src={raffle.raffleImage}
        style={raffle.background && { background: raffle.background }}
      />
      <RaffleItemDetails>
        <h3>{raffle.raffleName}</h3>
        <RaffleItemDetailsGrid>
          <p>
            <span>Entries:</span>{" "}
            {ended ? raffle.ticketsSold : totalTickets ?? 0}/{raffle.entries}
          </p>
          <p>
            <span>Winners:</span> {raffle.winners}
          </p>
          <p title={raffle.endDate}>
            {!ended ? (
              <>
                <span>Ends in:</span>{" "}
                <Countdown date={raffle.endDate} renderer={renderer} />
              </>
            ) : (
              <>
                <span>Burnt:</span>{" "}
                {(
                  (ended ? raffle.ticketsSold : totalTickets ?? 0) *
                  raffle.pricePerTicket
                )?.toLocaleString()}{" "}
                $SNEK
              </>
            )}
          </p>
        </RaffleItemDetailsGrid>
      </RaffleItemDetails>
      {!ended ? (
        <Link to={`/raffle/${raffle.raffleObjectId}`}>Join Raffle</Link>
      ) : (
        <Link className="winners" to={`/raffle/${raffle.raffleObjectId}`}>
          View Winners
        </Link>
      )}
    </RaffleItemContainer>
  );
};

export default RaffleItem;

const RaffleItemContainer = styled.div`
  background: #fff;
  flex-grow: 0;
  margin-bottom: 8px;

  @media only screen and (min-width: 768px) {
    flex-basis: 50%;
    margin: 8px;
    max-width: calc(50% - 16px);
  }

  @media only screen and (min-width: 1024px) {
    flex-basis: 33%;
    margin: 8px;
    max-width: calc(33% - 16px);
  }

  @media only screen and (min-width: 1200px) {
    flex-basis: 25%;
    margin: 8px;
    max-width: calc(25% - 16px);
  }

  a {
    align-items: center;
    background: #eb4b44;
    border-radius: 30px;
    color: #231f3d;
    display: flex;
    font-family: "Share Tech";
    font-size: 18px;
    justify-content: center;
    margin: 10px;
    min-height: 40px;

    &:hover {
      text-decoration: none;
    }

    &.winners {
      background: #6c6b87;
      border: 2px solid #6c6b87;
      color: #fff;
    }
  }
`;

const RaffleItemImage = styled.img`
  background: #eee;
  height: auto;
  width: 100%;
`;

const RaffleItemDetails = styled.div`
  /* height: 215px; */
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  color: rgb(35, 31, 61);
  font-family: "Share Tech";
  padding: 10px;
  position: relative;
  /* text-align: center; */

  h3 {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    color: rgb(35, 31, 61);
    /* font-family: "Share Tech"; */
    font-size: 24px;
    margin-bottom: 12px;
    padding-bottom: 12px;
  }

  p {
    color: rgb(35, 31, 61);
    /* color: #cccccc; */
    /* font-family: "Share Tech"; */
    font-size: 18px;
    font-weight: 400;
    line-height: 1.2;
    margin-bottom: 8px;

    &:last-of-type {
      margin-bottom: 0;
    }

    span {
      color: #555;
    }
  }
`;

const RaffleItemDetailsGrid = styled.div`
  /* display: grid; */
  /* grid-template-columns: 1fr 1fr; */
`;
